import { api } from "common";
import Chart from "react-apexcharts";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { useThemeApp } from "components/Theme/theme";
import { useSelector, useDispatch } from "react-redux";
import DashboardCard from "../components/DashboardCard";
import CircularLoading from "../components/CircularLoading";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { GoogleMap, InfoWindow, OverlayView } from "@react-google-maps/api";
import { Box, CardContent, IconButton, Paper, Typography } from "@mui/material";

const Dashboard = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { colors } = useThemeApp();
  const [totalgross, setTotalgross] = useState(0);
  const [dailygross, setDailygross] = useState(0);
  const [activeCount, setActiveCount] = useState(0);
  const [driverCount, setDriverCount] = useState(0);
  const [monthlygross, setMonthlygross] = useState(0);
  const [locations, setLocations] = useState<any>([]);
  const [customerCount, setCustomerCount] = useState(0);
  const [mylocation, setMylocation] = useState<any>(null);
  const [imageError, setImageError] = React.useState(false);
  const [allCancelCount, setAllCancelCount] = useState<any>([]);
  const [driverPendingCount, setDriverPendingCount] = useState(0);
  const [allCompleteCount, setAllCompleteCount] = useState<any>([]);
  const [selectedMarkerId, setSelectedMarkerId] = React.useState(null);
  const [driverCarPendingCount, setDriverCarPendingCount] = useState(0);

  const auth = useSelector((state) => state.auth);
  const cars = useSelector((state) => state.cartypes.cars);
  const usersdata = useSelector((state) => state.usersdata);
  const carlistdata = useSelector((state) => state.carlistdata);
  const settings = useSelector((state) => state.settingsdata.settings);
  const bookinglistdata = useSelector((state) => state.bookinglistdata);



  if (!auth.profile || auth.profile == null || !settings) return;

  const { fetchDrivers, clearFetchDrivers } = api;

  useEffect(() => {
    dispatch(fetchDrivers("ACTIVE"));
    return () => {
      dispatch(clearFetchDrivers());
    };
  }, [dispatch, fetchDrivers, clearFetchDrivers]);

  useEffect(() => {
    if (mylocation == null) {
      navigator.geolocation.getCurrentPosition(
        (position) =>
          setMylocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }),
        (error) => console.error(error)
      );
    }
  }, [mylocation]);


  useEffect(() => {
    if (usersdata.drivers && bookinglistdata.bookings) {
      const liveBookings = bookinglistdata.bookings.filter(
        (bkg) => bkg.status === "STARTED"
      );
      const drivers: any = usersdata.drivers;
      let locs = [];

      if (drivers && cars) {
        for (let i = 0; i < drivers.length; i++) {
          if (drivers[i].location) {
            let driverImage = undefined;
            let driverQueue = undefined;
            let bookingRef = null;

            driverImage = drivers[i].driverImage;

            driverQueue = drivers[i].queue;

            for (let j = 0; j < liveBookings.length; j++) {
              if (liveBookings[j].driver === drivers[i].uid) {
                bookingRef = liveBookings[j].reference;
              }
            }
            if (drivers && drivers[i] && drivers[i].location) {
              locs.push({
                id: i,
                driverQueue,
                bookingRef: bookingRef,
                driverImage: driverImage,
                cartype: drivers[i].carType,
                lat: drivers[i]?.location?.lat,
                lng: drivers[i]?.location?.lng,
                carnumber: drivers[i].vehicleNumber,
                drivername: drivers[i].firstName + " " + drivers[i].lastName,
              });
            }
          }
        }
        setLocations(locs);
      }
    }
  }, [
    cars,
    settings,
    usersdata.drivers,
    auth?.profile?.uid,
    auth?.profile?.usertype,
    bookinglistdata.bookings,
  ]);

  useEffect(() => {
    if (bookinglistdata.bookings) {
      let today = new Date();
      let monthlyTotal = 0;
      let yearlyTotal = 0;
      let todayTotal = 0;
      for (let i = 0; i < bookinglistdata.bookings.length; i++) {
        if (
          (bookinglistdata.bookings[i].status === "PAID" ||
            bookinglistdata.bookings[i].status === "COMPLETE")
        ) {
          const { tripdate, convenience_fees, driver_share, discount } =
            bookinglistdata.bookings[i];
          let tDate = new Date(tripdate);
          if (
            convenience_fees &&
            parseFloat(String(convenience_fees)) > 0
          ) {
            if (
              tDate.getDate() === today.getDate() &&
              tDate.getMonth() === today.getMonth() &&
              tDate.getFullYear() === today.getFullYear()
            ) {
              todayTotal =
                todayTotal +
                parseFloat(String(convenience_fees)) -
                parseFloat(String(discount));
            }
            if (
              tDate.getMonth() === today.getMonth() &&
              tDate.getFullYear() === today.getFullYear()
            ) {
              monthlyTotal =
                monthlyTotal +
                parseFloat(String(convenience_fees)) -
                parseFloat(String(discount));
            }
            yearlyTotal =
              yearlyTotal + parseFloat(String(convenience_fees)) - parseFloat(String(discount));
          }
          if (
            driver_share &&
            parseFloat(driver_share) > 0
          ) {
            if (
              tDate.getDate() === today.getDate() &&
              tDate.getMonth() === today.getMonth() &&
              tDate.getFullYear() === today.getFullYear()
            ) {
              todayTotal = todayTotal + parseFloat(driver_share);
            }
            if (
              tDate.getMonth() === today.getMonth() &&
              tDate.getFullYear() === today.getFullYear()
            ) {
              monthlyTotal = monthlyTotal + parseFloat(driver_share);
            }
            yearlyTotal = yearlyTotal + parseFloat(driver_share);
          }
        }
      }
      setDailygross(parseFloat(parseFloat(String(todayTotal)).toFixed(settings.decimal)));
      setMonthlygross(parseFloat(parseFloat(String(monthlyTotal)).toFixed(settings.decimal)));
      setTotalgross(parseFloat(parseFloat(String(yearlyTotal)).toFixed(settings.decimal)));
    }
  }, [
    bookinglistdata.bookings,
    settings,
    auth?.profile?.uid,
    auth?.profile?.usertype,
  ]);

  const barChartOptions = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    colors: ["#109496", "#f28e8e"],
    options: {
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
    },
  };

  const barChart = [
    {
      name: t("completed_bookings"),
      data: allCompleteCount,
    },
    {
      name: t("cancelled_bookings"),
      data: allCancelCount,
    },
  ];

  useEffect(() => {
    if (usersdata.users) {
      let driverCount = 0;
      let driverPendingCount = 0;
      let activeCount = 0;
      let customerCount = 0;
      for (let i = 0; i < usersdata.users.length; i++) {
        if (usersdata.users[i].usertype === "driver") {
          if (
            (auth?.profile?.usertype === "fleetadmin") ||
            auth?.profile?.usertype === "admin"
          ) {
            driverCount = driverCount + 1;
            if (!usersdata.users[i].approved)
              driverPendingCount = driverPendingCount + 1;

          }
        }
        if (usersdata.users[i].driverActiveStatus === true) {
          if (
            (auth?.profile?.usertype === "fleetadmin") ||
            auth?.profile?.usertype === "admin"
          ) {
            activeCount = activeCount + 1;
          }
        }
        if (usersdata.users[i].usertype === "customer") {
          if (
            (auth?.profile?.usertype === "fleetadmin") ||
            auth?.profile?.usertype === "admin"
          ) {
            customerCount = customerCount + 1;
          }
        }
      }
      setActiveCount(activeCount);
      setDriverCount(driverCount);
      setDriverPendingCount(driverPendingCount);
      setCustomerCount(customerCount);
    } else {
      setActiveCount(0);
      setDriverCount(0);
      setCustomerCount(0);
    }
  }, [usersdata.users, auth.profile]);

  useEffect(() => {
    let allCompleteCount = [];
    let allCancelCount = [];
    let months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    if (bookinglistdata.bookings) {
      for (let i = 0; i < months.length; i++) {
        let completeCount = 0;
        let cancelCount = 0;
        for (let j = 0; j < bookinglistdata.bookings.length; j++) {
          const { tripdate } = bookinglistdata.bookings[j];
          let tDate = new Date(tripdate);
          if (
            months[i] === months[tDate.getMonth()] &&
            (bookinglistdata.bookings[j].status === "PAID" ||
              bookinglistdata.bookings[j].status === "COMPLETE")
          ) {
            completeCount = completeCount + 1;
          }
          if (
            months[i] === months[tDate.getMonth()] &&
            bookinglistdata.bookings[j].status === "CANCELLED"
          ) {
            cancelCount = cancelCount + 1;
          }
        }
        allCompleteCount.push(completeCount);
        allCancelCount.push(cancelCount);
      }
    }
    setAllCompleteCount(allCompleteCount);
    setAllCancelCount(allCancelCount);
  }, [bookinglistdata.bookings]);


  useEffect(() => {
    if (carlistdata && carlistdata?.cars && carlistdata?.cars?.length > 0) {
      let carsPending = 0;

      for (let i = 0; i < carlistdata?.cars?.length; i++) {
        if (!carlistdata.cars[i].approved) {
          carsPending = carsPending + 1;
        }
      }
      setDriverCarPendingCount(carsPending)
    }
  }, [carlistdata?.cars]);


  return bookinglistdata.loading || usersdata.loading ? (
    <CircularLoading />
  ) : (
    <div>
      <Typography
        variant="h4"
        sx={{ margin: "20px 20px 0 15px", color: colors.primary, fontWeight: 600 }}
      >
        {t("gross_earning")}
      </Typography>

      <Grid container spacing={3} sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title={t("today_text")}
            icon={<AttachMoneyIcon sx={{ fontSize: 40, color: "#c6e2f6" }} />}
            crdStyle={{ height: "100%", display: "flex", borderRadius: "20px", backgroundColor: "#c6e2f6", transition: "transform 0.3s ease", '&:hover': { transform: "translateY(-5px)" } }}
          >
            <Typography variant="h5" fontWeight="bold">
              {settings.swipe_symbol === false
                ? settings.symbol + " " + dailygross
                : dailygross + " " + settings.symbol}
            </Typography>
          </DashboardCard>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title={t("this_month_text")}
            icon={<TrendingUpIcon sx={{ fontSize: 40, color: "#9fa8da" }} />}
            crdStyle={{ display: "flex", borderRadius: "20px", backgroundColor: "#9fa8da", height: "100%", transition: "transform 0.3s ease", '&:hover': { transform: "translateY(-5px)" } }}
          >
            <Typography variant="h5" fontWeight="bold">
              {settings.swipe_symbol === false
                ? settings.symbol + " " + monthlygross
                : monthlygross + " " + settings.symbol}
            </Typography>
          </DashboardCard>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DashboardCard
            title={t("total")}
            icon={<AccountBalanceIcon sx={{ fontSize: 40, color: "#42a5f5" }} />}
            crdStyle={{ display: "flex", borderRadius: "20px", backgroundColor: "#42a5f5", height: "100%", transition: "transform 0.3s ease", '&:hover': { transform: "translateY(-5px)" } }}
          >
            <Typography variant="h5" fontWeight="bold">
              {settings.swipe_symbol === false
                ? settings.symbol + " " + totalgross
                : totalgross + " " + settings.symbol}
            </Typography>
          </DashboardCard>
        </Grid>
      </Grid>


      <Grid container spacing={3} sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
        <Grid item xs={12} lg={8}>
          <Box
            sx={{
              boxShadow: 3,
              width: "100%",
              display: "flex",
              overflow: "hidden",
              borderRadius: "20px",
              flexDirection: "column",
              height: { xs: "400px", lg: "410px" },
            }}
          >
            <Typography
              variant="h5"
              sx={{ p: 2, fontWeight: 600 }}
            >
              {t("real_time_driver_section_text")}
            </Typography>

            {mylocation && mylocation.lat ? (
              <Box sx={{ flex: 1, position: "relative" }}>
                <GoogleMap
                  zoom={10}
                  center={mylocation}
                  mapContainerStyle={{ height: "100%", width: "100%" }}
                  options={{
                    colorScheme: 'DARK'
                  }}
                >
                  {locations.map((marker: any) => {
                    const isSelected = selectedMarkerId === marker.id;

                    const defaultImage = require('../assets/img/profilePic.png');
                    const imageUrl = imageError || !marker.driverImage ? defaultImage : marker.driverImage;
                    const borderColor = imageError || marker.driverQueue ? colors.danger : colors.primary;

                    return (
                      <React.Fragment key={marker.id}>
                        <OverlayView
                          position={{ lat: marker.lat, lng: marker.lng }}
                          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        >
                          <div
                            onClick={() => {
                              setSelectedMarkerId(isSelected ? null : marker.id);
                            }}
                            style={{
                              width: '45px',
                              height: '45px',
                              cursor: 'pointer',
                              overflow: 'hidden',
                              borderRadius: '50%',
                              position: 'relative',
                              backgroundColor: colors.card,
                              zIndex: isSelected ? 1000 : 1,
                              transform: 'translate(-50%, -50%)',
                              border: `3px solid ${borderColor}`,
                              transition: 'transform 0.2s, box-shadow 0.2s',
                              boxShadow: isSelected ? '0 4px 12px rgba(0,0,0,0.4)' : '0 2px 6px rgba(0,0,0,0.3)',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.1)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1)';
                              e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
                            }}
                          >
                            <img
                              src={imageUrl}
                              alt={marker.drivername}
                              onError={() => setImageError(true)}
                              style={{
                                width: '100%',
                                height: '100%',
                                display: 'block',
                                objectFit: 'cover',
                              }}
                            />
                          </div>
                        </OverlayView>
                        {isSelected && (
                          <OverlayView
                            position={{ lat: marker.lat, lng: marker.lng, }}
                            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                          >
                            <Paper
                              elevation={4}
                              sx={{
                                minWidth: '220px',
                                maxWidth: '280px',
                                overflow: 'visible',
                                position: 'relative',
                                borderRadius: '12px',
                                backgroundColor: colors.card,
                                transform: 'translate(-50%, -140%)',
                                border: `2px solid ${colors.primary}`,
                                '&::before': {
                                  content: '""',
                                  width: 0,
                                  height: 0,
                                  bottom: -20,
                                  left: '50%',
                                  position: 'absolute',
                                  transform: 'translateX(-50%)',
                                  borderLeft: '20px solid transparent',
                                  borderRight: '20px solid transparent',
                                  borderTop: `20px solid ${colors.primary}`,
                                }
                              }}
                            >
                              <Box sx={{ p: 1.5, pr: 4 }}>
                                <Typography variant="subtitle2" sx={{ color: colors.primary, fontWeight: 600 }}>
                                  {marker.drivername}
                                </Typography>
                                <Typography variant="caption" display="block" sx={{ color: colors.text + "70" }}>
                                  {marker.carnumber}
                                </Typography>
                                <Typography variant="caption" display="block" sx={{ color: marker.driverQueue ? colors.danger : colors.success, fontWeight: 500, mt: 0.5 }}>
                                  {marker.driverQueue ? t("queue") : t("NO_RACES_IN_PROGRESS")}
                                </Typography>
                              </Box>
                              <IconButton
                                size="small"
                                onClick={() => setSelectedMarkerId(null)}
                                sx={{ position: 'absolute', top: 4, right: 4, color: colors.text + "70" }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Paper>
                          </OverlayView>
                        )}
                      </React.Fragment>
                    );
                  })}
                </GoogleMap>
              </Box>
            ) : (
              <Box
                sx={{
                  p: 3,
                  display: "flex",
                  height: "100%",
                  textAlign: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h6" sx={{ mb: 1 }}>
                  {t("LOCATION_TIMEOUT_TITLE")}
                </Typography>
                <Typography variant="body1">
                  {t("LOCATION_PERMISSIONS_REQUIRED")}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>


        <Grid item xs={12} lg={4}>
          <Grid container spacing={2} sx={{ height: "100%" }}>
            <Grid item xs={6}>
              <Card
                sx={{
                  borderRadius: "20px",
                  backgroundColor: colors.primary,
                  minHeight: 130,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 3,
                  transition: "transform 0.3s ease",
                  '&:hover': { transform: "translateY(-5px)" }
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography color="white" fontSize={14} gutterBottom>
                    {t("total_cumtomer")}
                  </Typography>
                  <Typography color="white" fontSize={28} fontWeight="bold">
                    {customerCount}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card
                sx={{
                  borderRadius: "20px",
                  backgroundColor: "#26c6da",
                  minHeight: 130,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 3,
                  transition: "transform 0.3s ease",
                  '&:hover': { transform: "translateY(-5px)" }
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography color="white" fontSize={14} gutterBottom>
                    {t("total_drivers")}
                  </Typography>
                  <Typography color="white" fontSize={28} fontWeight="bold">
                    {driverCount}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card
                sx={{
                  borderRadius: "20px",
                  backgroundColor: "#7460ee",
                  minHeight: 130,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 3,
                  transition: "transform 0.3s ease",
                  '&:hover': { transform: "translateY(-5px)" }
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography color="white" fontSize={14} gutterBottom>
                    {t("active_driver")}
                  </Typography>
                  <Typography color="white" fontSize={28} fontWeight="bold">
                    {activeCount}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card
                onClick={() => nav("/users?driver=true")}
                sx={{
                  boxShadow: 3,
                  minHeight: 130,
                  display: "flex",
                  cursor: "pointer",
                  alignItems: "center",
                  borderRadius: "20px",
                  justifyContent: "center",
                  backgroundColor: "#ff9800",
                  transition: "transform 0.3s ease",
                  '&:hover': { transform: "translateY(-5px)" }
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography color="white" fontSize={14} gutterBottom>
                    {t('pending_drivers')}
                  </Typography>
                  <Typography color="white" fontSize={28} fontWeight="bold">
                    {driverPendingCount}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Card
                onClick={() => nav("/cars")}
                sx={{
                  boxShadow: 3,
                  minHeight: 100,
                  display: "flex",
                  cursor: "pointer",
                  borderRadius: "20px",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f44336",
                  transition: "transform 0.3s ease",
                  '&:hover': { transform: "translateY(-5px)" }
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography color="white" fontSize={16} gutterBottom>
                    {t('pending_cars')}
                  </Typography>
                  <Typography color="white" fontSize={32} fontWeight="bold">
                    {driverCarPendingCount}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>


      <Box sx={{ m: { xs: 1, sm: 2, md: 3 }, borderRadius: "20px", p: 2, boxShadow: 3 }}    >
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: 600 }}
        >
          {t("booking_chart")}
        </Typography>
        <Chart
          type="area"
          width="100%"
          height={360}
          series={barChart}
          options={barChartOptions}
        />
      </Box>
    </div>
  );
};

export default Dashboard;